module.exports = __webpack_public_path__ + "img/gather_ruffle.4effa81d.png";